export default __webpack_public_path__ + "static/media/cerca-poi.3b376ad2.png";